export const isMacLike = () => {
    const globalObject = typeof globalThis !== 'undefined' ? globalThis : window;
    return /(Mac|iPhone|iPod|iPad)/i.test(globalObject.navigator.platform);
};
